import axios from '../plugins/axios'

export default {
    update_host({url}){
      return axios.post('/api/v1/users/update_host', {url: url})
    },
    accept_policy(policy_version){
      return axios.post('/api/v1/users/accept_policy', { policy_version: policy_version })
    },
    save_user_info(params){
      return axios.post('/api/v1/users/save_user_info', params)
    },
    save_service_change(){
      return axios.post('/api/v1/users/save_service_change')
    },
    markHeatmapOnboardingSeen(){
      return axios.post('/api/v1/users/heatmap_onboarding_seen')
    },
}
